import React, { useEffect, useReducer } from "react";
import { useCombinedReducer } from "../../js/reactUtils/reactUtils.js";
import {
  contactGroupsListReducer,
  filterReducer,
  editContactsReducer,
  companyReducer,
  allContactsReducer,
  contactsListReducer,
  editGroupsReducer,
  contactSelectionsReducer,
  unsubscribesReducer,
  connectionRequestsReducer,
  connectionRequestCountReducer,
  connectionsReducer,
  columnsDisplayReducer,
  contactsContextFetchStateReducer,
  entireListOfContactsReducer,
  fetchContactsReducer,
  pageSizeReducer,
  paginationTokenReducer,
  fetchContactListssReducer,
  pageReducer,
  countReducer,
  pageMapReducer,
  textQueryFilterReducer,
  orderByReducer,
  sortByReducer,
} from "./ContactsReducers";

import axios from "axios";
import PropTypes from "prop-types";

export const ContactsContext = React.createContext({});

export const ContactsContextProvider = (props) => {
  const [state, dispatch] = useCombinedReducer({
    contactLists: useReducer(contactGroupsListReducer, ["SENTINEL"]),
    allContactsGroup: useReducer(allContactsReducer, {}),
    filter: useReducer(filterReducer, {
      selectedContactGroupId: "",
      contactFilter: "ALL_CONTACTS",
    }),
    companyState: useReducer(companyReducer, {}),
    orderBy: useReducer(orderByReducer, "desc"),
    sortBy: useReducer(sortByReducer, "created_timestamp"),
    listOfContacts: useReducer(contactsListReducer, {
      filtered: [],
      original: [],
    }),
    editContactState: useReducer(editContactsReducer, {
      editing: false,
      contactId: "",
    }),
    editGroupState: useReducer(editGroupsReducer, {
      editing: false,
      groupId: "",
    }),
    contactSelectionsState: useReducer(contactSelectionsReducer, []),
    unsubscribes: useReducer(unsubscribesReducer, []),
    connectionRequests: useReducer(connectionRequestsReducer, []),
    connectionRequestCount: useReducer(connectionRequestCountReducer, []),
    connections: useReducer(connectionsReducer, []),
    useConnectionRequestColumns: useReducer(columnsDisplayReducer, false),
    fetching: useReducer(contactsContextFetchStateReducer, true),
    entireListOfContacts: useReducer(entireListOfContactsReducer, []),
    fetchingContacts: useReducer(fetchContactsReducer, true),
    fetchingContactLists: useReducer(fetchContactListssReducer, false),
    pageSize: useReducer(pageSizeReducer, 50),
    paginationToken: useReducer(paginationTokenReducer, null),
    page: useReducer(pageReducer, 0),
    pageMap: useReducer(pageMapReducer, {}),
    count: useReducer(countReducer, 0),
    textQueryFilter: useReducer(textQueryFilterReducer, ""),
  });

  useEffect(() => {
    const fetchCompanyInfo = async function () {
      let result = await axios.get("/api/v2/companies/name/" + props.companyName);
      let company = result.data;

      dispatch({
        type: "SET_COMPANY",
        payload: company,
      });

      dispatch({
        type: "FETCHING_LISTS",
      });

      let emailListResult;
      try {
        emailListResult = await axios.get(
          "/api/v2/companies/" + company.project_id + "/email_lists"
        );
      } catch (err) {
        console.error(err);
      }

      let allContactsEmailListMatch = emailListResult.data.filter(
        (emailList) => emailList.is_all_contacts === true
      );

      let nonAllContactsEmailLists = emailListResult.data.filter(
        (emailList) => emailList.is_all_contacts === false
      );

      let allContactsEmailList = allContactsEmailListMatch[0];

      dispatch({
        type: "SET_ALL_CONTACTS_LIST",
        payload: allContactsEmailList,
      });

      dispatch({
        type: "FINISHED_LISTS",
      });

      let connections_result = [];
      let connectionRequests = [];
      try {
        connections_result = await axios.get(
          "/api/v2/companies/" + company.project_id + "/connection_requests"
        );
        connectionRequests = connections_result.data.data.map((user) => {
          let initials = "";
          if (user.first_name && user.last_name) {
            initials =
              user.first_name[0].toUpperCase() +
              user.last_name[0].toUpperCase();
          } else if (user.email) {
            initials = user.email[0].toUpperCase();
          }
          user.displayObj = {
            fullName: (user.first_name || "") + " " + (user.last_name || ""),
            firstName: user.first_name || "",
            lastName: user.last_name || "",
            email: user.email,
            userInitials: initials,
          };
          return user;
        });
      } catch (err) {
        console.log(err.stack);
      }

      dispatch({
        type: "SET_CONNECTION_REQUESTS",
        payload: connectionRequests,
      });

      dispatch({
        type: "SET_CONNECTION_REQUESTS_COUNT",
        payload: connections_result.data.pagination.total,
      });

      dispatch({
        type: "SET_CONTACT_GROUPS",
        payload: emailListResult.data.filter((emailList) => {
          return emailList.is_all_contacts === false;
        }),
      });

      let urlArray = window.location.href.split("/");
      let indexOfId = urlArray.indexOf("group") + 1;
      const contact_group_id = urlArray[indexOfId];

      if (indexOfId == 0) {
        dispatch({
          type: "FILTER_SELECTED_CONTACTS",
          payload: "ALL_CONTACTS",
        });
      }

      dispatch({
        type: "SELECT_CONTACT_GROUP",
        payload:
          indexOfId == 0
            ? allContactsEmailList.email_list_id
            : contact_group_id,
      });

      dispatch({
        type: "SET_FETCHING",
        payload: false,
      });
    };

    fetchCompanyInfo();
  }, [props.companyName]);

  return (
    <ContactsContext.Provider value={[state, dispatch]}>
      {props.children}
    </ContactsContext.Provider>
  );
};
export const ContactsContextConsumer = ContactsContext.Consumer;

ContactsContextProvider.propTypes = {
  children: PropTypes.element,
};
